import React, { useMemo, useRef, useState } from "react";
import { axios } from "../../../../utils/useAxios";
import { useCallback, useEffect } from "react";
import { Button, Col, Input, Modal, Row, Table } from "antd";
import { FaCogs } from "react-icons/fa";
import numeral from "numeral";
import _ from "lodash";

const ManageModal = ({
  visible,
  onCancel,
  setDetail,
  disableProduct,
  setDisableProduct,
}) => {
  const [loading, setLoading] = useState(false);
  const [product, setProduct] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [search, setSearch] = useState("");
  const searchRef = useRef("");
  const columns = [
    {
      width: 60,
      title: "ลำดับ",
      key: "row_id",
      dataIndex: "row_id",
      align: "center",
    },
    {
      width: 100,
      className: "position-relative",
      title: <div className="ant-table-absolute-title-center">รหัสสินค้า</div>,
      key: "product_code",
      dataIndex: "product_code",
    },
    {
      className: "position-relative",
      title: <div className="ant-table-absolute-title-center">ชื่อสินค้า</div>,
      key: "product_name",
      dataIndex: "product_name",
    },
    {
      width: 100,
      className: "position-relative",
      title: (
        <div className="ant-table-absolute-title-center">จำนวนคงเหลือ</div>
      ),
      key: "stock_balance",
      dataIndex: "stock_balance",
      align: "right",
      render: (text) => numeral(text).format("0,0"),
    },
    {
      width: 80,
      title: <FaCogs />,
      align: "center",
      key: "action",
      render: (record) => (
        <Button
          type="primary"
          size="small"
          onClick={() => {
            setDetail({
              ...record,
              package_qty: Number(record.package_qty) || 0,
              total_qty: Number(record.total_qty) || 0,
              total_volume: Number(record.total_volume) || 0,
            });
            setDisableProduct((prev) =>
              prev ? `${prev},${record.product_code}` : record.product_code,
            );
            // setSearch("");
          }}
        >
          เพิ่ม
        </Button>
      ),
    },
  ];

  const fetchProduct = useCallback(
    async (page = 1, limit = 10, searchValue = "") => {
      try {
        setLoading(true);
        const offset = (page - 1) * limit;
        const res = await axios.get("/requisition-branch/products", {
          params: {
            offset,
            limit,
            branchCode: "300",
            search: searchValue,
            disableProduct: disableProduct,
          },
        });
        setProduct(res.data.data);
        setPagination((prev) => ({
          ...prev,
          current: page,
          total: res.data.total,
        }));
      } catch (e) {
        console.log(e);
      } finally {
        setLoading(false);
      }
    },
    [disableProduct],
  );
  const debouncedSearch = useMemo(
    () =>
      _.debounce((value) => {
        fetchProduct(1, 10, value);
      }, 400),
    [fetchProduct],
  );
  const handleClose = () => {
    setSearch("");
    searchRef.current = "";
    onCancel();
  };

  useEffect(() => {
    if (!visible) return;
    fetchProduct(1, 10, searchRef.current);
  }, [fetchProduct, visible]);

  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);
  return (
    <div>
      <Modal
        title="เพิ่มสินค้า"
        visible={visible}
        footer={false}
        zIndex={1080}
        width={1000}
        destroyOnClose
        onCancel={handleClose}
      >
        <Row className="mb-3" type="flex">
          <Col span={16}>
            <Input.Search
              allowClear
              placeholder="รหัสสินค้า, ชื่อสินค้า, SKU, Barcode"
              value={search}
              onChange={(e) => {
                const value = e.target.value;
                setSearch(value);
                searchRef.current = value;
                debouncedSearch(value);
              }}
            />
          </Col>
        </Row>
        <Table
          size="small"
          bordered
          loading={loading}
          dataSource={product || []}
          rowKey="id"
          pagination={{
            ...pagination,
            showLessItems: true,
            size: "small",
            onChange: (page, limit) =>
              fetchProduct(page, limit, searchRef.current),
          }}
          columns={columns}
        />
      </Modal>
    </div>
  );
};

export default ManageModal;
